import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { Box, Paper, Stack, Typography } from '@mui/material';

/**
 * Lightweight kanban board used by the CRM module. The consumer supplies
 * columns = [{ id, title, items }] and handles onMove(fromCol, toCol, itemId, index).
 */
export default function KanbanBoard({ columns = [], onMove, renderCard }) {
  const handle = (result) => {
    if (!result.destination) return;
    onMove?.({
      from: result.source.droppableId,
      to: result.destination.droppableId,
      itemId: result.draggableId,
      index: result.destination.index,
    });
  };

  return (
    <DragDropContext onDragEnd={handle}>
      <Stack direction="row" spacing={2} sx={{ overflowX: 'auto', pb: 2, alignItems: 'flex-start' }}>
        {columns.map((col) => (
          <Paper key={col.id} sx={{ minWidth: 280, p: 1.5, bgcolor: 'background.default' }}>
            <Typography variant="subtitle2" sx={{ mb: 1, px: 1 }}>
              {col.title} · {col.items.length}
            </Typography>
            <Droppable droppableId={col.id}>
              {(p) => (
                <Box ref={p.innerRef} {...p.droppableProps} sx={{ minHeight: 60 }}>
                  {col.items.map((item, index) => (
                    <Draggable key={item.id} draggableId={String(item.id)} index={index}>
                      {(pd) => (
                        <Box
                          ref={pd.innerRef}
                          {...pd.draggableProps}
                          {...pd.dragHandleProps}
                          sx={{ mb: 1 }}
                        >
                          {renderCard ? renderCard(item) : <Paper sx={{ p: 1.5 }}>{item.title || item.name}</Paper>}
                        </Box>
                      )}
                    </Draggable>
                  ))}
                  {p.placeholder}
                </Box>
              )}
            </Droppable>
          </Paper>
        ))}
      </Stack>
    </DragDropContext>
  );
}
